import { apiGeneric } from '../http';
import ServiceCRUD from './ServiceCRUDFLEXUC';

export class ServiceUnifiedMonitoring extends ServiceCRUD {
  headers = {};

  constructor() {
    super(process.env.REACT_APP_UNIFIED_MONITORING);
    this.headers = {
      Authorization: localStorage.getItem('token')
    };
  }

  getInitialData() {
    return apiGeneric.get(`${this.path}/initial`, {
      headers: this.headers
    });
  }
}
